<template>
  <div class="root">
    <!-- 头部 -->
    <div class="wms-top">
      <div>
        <div class="wms-top-card">
          <div class="wms-top-card-title">入库订单数(个)</div>
          <div class="wms-top-card-count" style="color: cornflowerblue">{{rkNumber}}</div>
        </div>
      </div>
      <div>
        <div class="wms-top-card">
          <div class="wms-top-card-title">出库订单数(个)</div>
          <div class="wms-top-card-count" style="color: darkmagenta">{{ckNumber}}</div>
        </div>
      </div>
      <div>
        <div class="wms-top-card">
          <div class="wms-top-card-title">盘点订单数(个)</div>
          <div class="wms-top-card-count" style="color: maroon">{{pdNumber}}</div>
        </div>
      </div>
      <div>
        <div class="wms-top-card">
          <div class="wms-top-card-title">总库存</div>
          <div class="wms-top-card-count" style="color: mediumblue">{{zkc}}</div>
        </div>
      </div>
      <div>
        <div class="wms-top-card">
          <div class="wms-top-card-title">未完成订单数(个)</div>
          <div class="wms-top-card-count" style="color: olivedrab">{{ykNumber}}</div>
        </div>
      </div>
    </div>
    <!-- 头部（结束）-->
    <!-- 中间 -->
    <div class="wms-middle">
      <div>
        <div class="wms-middle-card">
          <div class="wms-middle-card-title">入、出、盘异常订单</div>
          <div class="wms-middle-card-content">
            <WMSEcharts :chartOption="errChartOption" :echartStyle="echartStyle"></WMSEcharts>
          </div>
        </div>
      </div>
      <div>
        <div class="wms-middle-card">
          <div class="wms-middle-card-title">每日入库订单TOP10</div>
          <div class="wms-middle-card-content">
            <WMSEcharts :chartOption="rkqkChartOption" :echartStyle="echartStyle"></WMSEcharts>
          </div>
        </div>
      </div>
      <div>
        <div class="wms-middle-card">
          <div class="wms-middle-card-title">每日出库订单TOP10</div>
          <div class="wms-middle-card-content">
            <WMSEcharts :chartOption="ckqkChartOption" :echartStyle="echartStyle"></WMSEcharts>
          </div>
        </div>
      </div>
      <div>
        <div class="wms-middle-card">
          <div class="wms-middle-card-title">每层容器指令数</div>
          <div class="wms-middle-card-content">
            <WMSEcharts :chartOption="commandChartOption" :echartStyle="echartStyle"></WMSEcharts>
          </div>
        </div>
      </div>
    </div>
    <!-- 中间（结束）-->
    <!-- 底部（开始） -->
    <div class="wms-bottom">
      <div>
        <div class="wms-bottom-card">
          <div class="wms-bottom-card-title">容器使用率</div>
          <div class="wms-bottom-card-content">
            <WMSEcharts :chartOption="containerUtilizationChartOption" :echartStyle="echartStyle"></WMSEcharts>
          </div>
        </div>
      </div>
      <div>
        <div class="wms-middle-card">
          <div class="wms-bottom-card-title">库存情况</div>
          <div class="wms-bottom-card-content">
            <WMSEcharts :chartOption="inventoryChartOption" :echartStyle="echartStyle"></WMSEcharts>
          </div>
        </div>
      </div>
      <div>
        <div class="wms-middle-card">
          <div class="wms-middle-card-title">货位利用率</div>
          <div class="wms-middle-card-content">
            <WMSEcharts :chartOption="LocationUtilizationChartOption" :echartStyle="echartStyle"></WMSEcharts>
          </div>
        </div>
      </div>
      <!--      <div class="wms-bottom-content">-->
      <!--        <WMSEcharts :echartStyle="echartStyle" :chartOption="ckqkChartOption"></WMSEcharts>-->
      <!--      </div>-->
    </div>
    <!-- 底部（结束） -->
  </div>
</template>

<script>
  import WMSEcharts from './WMSEcharts'
  import WMSBallStep from './WMSBallStep'
  import WMSBallStepH from './WMSBallStepH'

  export default {
    name: 'Home',
    components: { WMSEcharts, WMSBallStep, WMSBallStepH },
    data() {
      return {
        timer: '',
        rkNumber: 1,
        ckNumber: 2,
        ykNumber: 3,
        pdNumber: 4,
        zkc: 0,
        rkSteps: [
          { title: '入库计划', number: 0 },
          { title: '入库审核', number: 0 },
          { title: '入库开票', number: 0 },
          { title: '错误处理', number: 0 },
          { title: '入库上架', number: 0 }
        ],
        ckSteps: [
          { title: '出库计划', number: 0 },
          { title: '出库审核', number: 0 },
          { title: '调度下发', number: 0 },
          { title: '任务拣选', number: 0 },
          { title: '外复核', number: 0 },
          { title: '出库交接', number: 0 }
        ],
        echartStyle: { width: '100%', height: '100%' },
        errChartOption: {
          color: ['#4cabce', '#FFA07A', '#40E0D0'],
          legend: {
            top: 'bottom'
          },
          toolbox: {
            show: true,
            feature: {
              mark: { show: true },
              dataView: { show: true, readOnly: false },
              restore: { show: true },
              saveAsImage: { show: false }
            }
          },
          series: [
            {
              name: '面积模式',
              type: 'pie',
              radius: [20, 100],
              center: ['50%', '50%'],
              roseType: 'area',
              itemStyle: {
                borderRadius: 8
              },
              data: [
                { value: 26, name: '入库订单' },
                { value: 22, name: '出库订单' },
                { value: 59, name: '盘点订单' }
              ]
            }
          ]
        },
        rkqkChartOption: {
          color: ['#4cabce'],
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar'
          }]
        },
        ckqkChartOption: {
          dataset: {
            source: [
              ['score', 'amount', 'product'],
              [230, 230, 'A单位'],
              [43, 43, 'B单位'],
              [53, 53, 'C单位'],
              [63, 63, 'D单位']

            ]
          },
          grid: { containLabel: true },
          xAxis: { name: '订单数' },
          yAxis: { type: 'category' },
          visualMap: {
            orient: 'horizontal',
            left: 'center',
            min: 0,
            max: 1000,
            text: ['High', 'Low'],
            // Map the score column to color
            dimension: 0,
            inRange: {
              color: ['#65B581', '#FFCE34', '#FD665F']
            }
          },
          series: [
            {
              type: 'bar',
              encode: {
                // Map the "amount" column to X axis.
                x: 'amount',
                // Map the "product" column to Y axis
                y: 'product'
              }
            }
          ]
        },
        commandChartOption: {
          color: ['#4cabce'],
          xAxis: {
            type: 'category',
            data: ['0', '2', '4', '6', '8', '10', '12', '14', '16', '18', '20', '22', '24']
          },
          yAxis: {
            type: 'value'
          },
          series: [{
            data: [150, 230, 224, 218, 135, 260, 34, 22, 1, 67, 89],
            type: 'line'
          }]
        },
        containerUtilizationChartOption: {
          color: ['#4cabce', '#FFA07A'],
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left'
          },
          series: [
            {
              name: '容器',
              type: 'pie',
              radius: '70%',
              data: [
                { value: 38, name: '容器使用数' },
                { value: 32, name: '未使用数' }
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        },
        inventoryChartOption: {
          color: ['#4cabce'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['逻辑区域1', '逻辑区域2', '逻辑区域3', '逻辑区域4', '逻辑区域5', '逻辑区域6', '逻辑区域7', '逻辑区域8'],
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '库存数量',
              type: 'bar',
              barWidth: '40%',
              data: [130, 582, 200, 334, 390, 330, 220, 456, 666]
            }
          ]
        },
        LocationUtilizationChartOption: {
          color: ['#4cabce', '#FFA07A'],
          legend: {},
          tooltip: {},
          dataset: {
            source: [
              ['product', '空闲', '非空闲'],
              ['逻辑区域1', 32, 85],
              ['逻辑区域2', 83, 73],
              ['逻辑区域3', 86, 65],
              ['逻辑区域4', 72, 53]
            ]
          },
          xAxis: { type: 'category' },
          yAxis: { type: 'value' },
          series: [
            { type: 'bar' },
            { type: 'bar' }
          ]

        },

        ssqk: [],
        zzjhrw: [],
        dsqrw: [],
        wjhrw: []
      }
    },
    mounted: function() {
      this.refresh()
      this.timer = this.timer = setInterval(this.refresh, 5000)
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    methods: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .root {
    width: 100%;
    height: 100%;
  }

  .wms-top {
    width: 100%;
    height: 15%;
    margin-top: -20px;
    display: flex;
  }

  .wms-top > div {
    flex: 1;
    height: 100%;
    padding: 10px;
  }

  .wms-top-card {
    border: 1px solid #eee;
    border-radius: 5px;
    height: 100%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  }

  .wms-top-card-title {
    padding-top: 5%;
    height: 50%;
    line-height: 100%;
    margin-left: 20px;
  }

  .wms-top-card-count {
    height: 50%;
    line-height: 100%;
    font-size: x-large;
    color: rebeccapurple;
    text-align: center;
  }

  .wms-middle {
    width: 100%;
    height: 55%;
    display: flex;
  }

  .wms-middle > div {
    flex: 1;
    height: 100%;
    padding: 10px;
  }

  .wms-middle-card {
    border: 1px solid #eee;
    border-radius: 5px;
    height: 100%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  }

  .wms-middle-card-title {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    background-color: #eee;
  }

  .wms-middle-card-content {
    height: calc(100% - 30px);
    position: relative;
  }

  .wms-middle-card-content-top {
    height: 33.33%;
    display: flex;
  }

  .wms-middle-card-content-middle {
    height: 33.33%;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    display: flex;
  }

  .wms-middle-card-content-bottom {
    height: 33.33%;
    display: flex;
  }

  .wms-middle-card-content-left {
    width: 20%;
    position: relative;
    border-right: 1px solid #eee;
  }

  .wms-middle-card-content-left > div {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    line-height: 20px;
    transform: translate(-50%, -50%);
  }

  .wms-middle-card-content-right {
    flex: 1;
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  .wms-middle-card-content-right-card {
    width: 50%;
    height: 25%;
    float: left;
    display: flex;
    justify-content: space-around;
    overflow: hidden;
  }

  .wms-middle-card-content-right-content {
    position: absolute;
    left: 0;
    top: 0;
    min-width: 100%;
    overflow: hidden;
    /* animation: roll 5s infinite linear; */
  }

  /* @keyframes roll {
    0% {
      top: 0;
      bottom: auto;
    }
    100% {
      top: auto;
      bottom: 0;
    }
  } */

  /* .wms-middle-card-content-line {
    height: 10%;
    display: flex;
  }
  .wms-middle-card-content-line-title {
    flex: 2;
    text-align: right;
    margin: auto 0 0 0;
  }
  .wms-middle-card-content-line-desc {
    flex: 3;
    margin: auto 0 0 5%;
    text-align: left;
  } */

  .wms-bottom {
    width: 100%;
    height: 30%;
    display: flex;
  }

  .wms-bottom > div {
    flex: 1;
    height: 100%;
    padding: 10px;
  }

  .wms-bottom-card {
    border: 1px solid #eee;
    border-radius: 5px;
    height: 100%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  }

  .wms-bottom-card-title {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    background-color: #eee;
  }

  .wms-bottom-card-content {
    height: calc(100% - 30px);
    position: relative;
  }

  .wms-bottom-content {
    height: 100%;
    border: 1px solid #eee;
    border-radius: 5px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    padding: 10px;
  }
</style>
